<template>

    <v-modal title="ShoutOUT" :loading="starting">

        <template #body v-if="!integration">
            <v-notice type="danger" size="sm" :message="$t('action.connect')" />
        </template>

        <template #body v-else>
            <v-alert :message="error" />
            <v-form-group dir="ver" label="SMS Sender ID">
                <v-select :model="params.sms_sender_id" @input="params.sms_sender_id = $event">
                    <option value="">Select Sender</option>
                    <option v-for="sender in integration.subloads.senders" :key="sender" :value="sender">{{ sender }}</option>
                </v-select>
            </v-form-group>
            <v-form-group dir="ver" label="Message">
                <v-textarea-variable :model="params.body" @input="params.body = $event" />
            </v-form-group>
            <v-form-group dir="ver" label="Custom Recipient">
                <v-input placeholder="Phone Number" :model="params.recipient" @input="params.recipient = $event" />
            </v-form-group>
            <v-form-group dir="ver">
                <v-checkbox label="Track Links" :model="params.track_links" @input="params.track_links = $event" />
            </v-form-group>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button v-if="integration" size="sm" :loading="loading" @click.native="saveAction">Save</v-button>
            <v-button v-else size="sm" :loading="loading" @click.native="connectAction">Connect Integration</v-button>
        </template>

    </v-modal>

</template>

<script>

import ModalActionMixin from '@mixins/ModalActionMixin';

export default {

    mixins: [ModalActionMixin],

    data() {
        return {
            params: {
                type: this.action.type,
                sms_sender_id: this.action.sms_sender_id,
                body: this.action.body,
                recipient: this.action.recipient,
                track_links: this.action.track_links,
            },
        }
    },

    mounted() {
        this.getIntegration(this.action.type);
    },

}

</script>
